/**
 * Split two-panel menu drawer interaction.
 * Left panel: nav item list
 * Right panel: corresponding category content
 */
(function () {
    /**
     * Reads the real bottom-edge of the header section and stores it as
     * CSS custom properties so drawer + overlay can use identical values.
     */
    function updateDrawerTop() {
        // .header-wrapper is the nearest wrapper that ends right where the
        // drawer should begin. Fall back to section-header if needed.
        const headerEl =
            document.querySelector('.header-wrapper') ||
            document.querySelector('.section-header');

        if (!headerEl) return;

        const rect = headerEl.getBoundingClientRect();
        // bottom = distance from viewport top to the bottom edge of the header
        const headerBottom = Math.round(rect.bottom);
        // Use visualViewport.height (updates on mobile toolbar show/hide)
        // --drawer-height is kept for the overlay ::before pseudo-element
        const viewportHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;
        const drawerHeight = viewportHeight - headerBottom;

        document.documentElement.style.setProperty('--drawer-top', headerBottom + 'px');
        document.documentElement.style.setProperty('--drawer-height', drawerHeight + 'px');
    }

    function initSplitMenuDrawer() {
        const drawer = document.querySelector('.menu-drawer__navigation--split');
        if (!drawer) return;

        const leftItems = drawer.querySelectorAll('.menu-drawer__nav-left-item');
        const panels = drawer.querySelectorAll('.menu-drawer__nav-panel');

        function activateItem(item) {
            leftItems.forEach((el) => el.classList.remove('menu-drawer__nav-left-item--active'));
            item.classList.add('menu-drawer__nav-left-item--active');

            const targetId = item.dataset.target;
            panels.forEach((panel) => {
                if (panel.id === targetId) {
                    panel.parentElement.scrollTop = 0;
                    panel.style.display = 'block';
                } else {
                    panel.style.display = 'none';
                }
            });
        }

        leftItems.forEach((item) => {
            item.addEventListener('click', function (e) {
                if (this.dataset.target) {
                    e.preventDefault();
                    activateItem(this);
                }
            });
        });

        // Auto-activate first item that has a panel
        const firstWithPanel = Array.from(leftItems).find((item) => item.dataset.target);
        if (firstWithPanel) activateItem(firstWithPanel);
    }

    function init() {
        updateDrawerTop();
        initSplitMenuDrawer();
    }

    // Run on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    // Re-measure when drawer opens (announcement bar may have scrolled away)
    document.addEventListener('click', function (e) {
        const summary = e.target.closest(
            '#Details-menu-drawer-container > summary, .header__icon--menu'
        );
        if (summary) {
            // Small delay so the details[open] state is applied first
            setTimeout(function () {
                updateDrawerTop();
                initSplitMenuDrawer();
            }, 50);
        }
    });

    // Keep values fresh on resize / orientation change
    window.addEventListener('resize', updateDrawerTop);

    // visualViewport fires when mobile browser toolbar shows/hides
    // (window 'resize' does NOT fire reliably in that case on mobile)
    if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', updateDrawerTop);
    }
})();
